// Excel-locked AIP calculator
// Mirrors the official spreadsheet logic: CTW, support/interaction, substitution, env adjustment.

const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

const clamp01 = (x) => Math.max(0, Math.min(1, x));
const clamp0100 = (x) => Math.max(0, Math.min(100, x));

export function calculateAipExcel(inputs = {}) {
  const FWB = toNum(inputs.FWB);
  const CT = toNum(inputs.CT);
  const ES = toNum(inputs.ES);

  const lambda = toNum(inputs.lambda) ?? 0.3;
  const gamma = toNum(inputs.gamma) ?? 0.5;
  const sigma = toNum(inputs.sigma) ?? 0.8;
  const kappa = toNum(inputs.kappa) ?? 0.77;

  if (FWB == null || CT == null || ES == null) {
    return { score: null, status: "Needs Data" };
  }

  const f = clamp01(FWB / 100);
  const c = clamp01(CT / 100);
  const e = clamp01(ES / 100);

  const CTW = 1 - f;
  const supportIndex = CTW * c;
  const interaction = f * CTW * c;
  const careBoost = 0.4 * supportIndex + 0.6 * interaction;

  const ICS = 100 * f + careBoost;
  const careInfluence = 1 - clamp01(lambda);
  const extraSub =
    (100 - ICS) *
    clamp01(kappa) *
    clamp01(sigma) *
    supportIndex *
    careInfluence;
  const ICS_plus = ICS + extraSub;

  const envAdjustment = 1 - clamp01(gamma) * (1 - e);
  const finalAipRaw = ICS_plus * envAdjustment;
  const score = Math.round(clamp0100(finalAipRaw));

  const status =
    score >= 80 ? "Good" : score >= 60 ? "Moderate" : "At Risk";

  return {
    score,
    status,
    debug: {
      FWB,
      CT,
      ES,
      lambda,
      gamma,
      sigma,
      kappa,
      f,
      c,
      e,
      CTW,
      supportIndex,
      interaction,
      careBoost,
      ICS,
      extraSub,
      ICS_plus,
      envAdjustment,
      finalAipRaw,
    },
  };
}



